import { attendanceServiceApi } from "../../app/attendanceServiceApi";
import { API_URL } from "../../constants/apiUrl";
import { GetQueryArgsType } from "../../types";
import {
  GetAttendanceLog,
  GetCustomAttendanceByEmployeeParams,
  GetCustomAttendanceByEmployeeResponseType,
  GetCustomAttendanceParams,
  GetCustomAttendanceReportResponseType,
  GetDailyAttendanceReportParams,
  GetDailyAttendanceReportResponseType,
  GetDashboardAttendanceAnalyticsDataParams,
  GetDashboardAttendanceAnalyticsDataResponseType,
} from "../../types/attendance";

export const attendanceReportApi = attendanceServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getDailyAttendanceReport: builder.query<
      GetDailyAttendanceReportResponseType,
      GetQueryArgsType<GetDailyAttendanceReportParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getDailyAttendanceReport,
        ...queryArgs,
      }),
    }),
    getCustomAttendanceReport: builder.query<
      GetCustomAttendanceReportResponseType,
      GetQueryArgsType<GetCustomAttendanceParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getCustomAttendanceReport,
        ...queryArgs,
      }),
    }),

    getCustomAttendanceByEmployee: builder.query<
      GetCustomAttendanceByEmployeeResponseType,
      GetQueryArgsType<GetCustomAttendanceByEmployeeParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getCustomAttendanceByEmployee,
        ...queryArgs,
      }),
      providesTags: ["GetCustomAttendanceByEmployee"],
    }),
    attendanceReconciliation: builder.mutation({
      query: (data) => ({
        url: API_URL.attendanceReconciliation,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["GetCustomAttendanceByEmployee"],
    }),

    getDashboardAttendanceAnalyticsData: builder.query<
      GetDashboardAttendanceAnalyticsDataResponseType,
      GetQueryArgsType<GetDashboardAttendanceAnalyticsDataParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getDashboardAttendanceAnalyticsData,
        ...queryArgs,
      }),
    }),
    getAttendanceLog: builder.query<GetAttendanceLog, number>({
      query: (id) => ({
        url: `${API_URL.getAttendanceLog}/${id}`,
      }),
    }),
  }),
});

export const {
  useGetDailyAttendanceReportQuery,
  useGetCustomAttendanceReportQuery,
  useGetCustomAttendanceByEmployeeQuery,
  useAttendanceReconciliationMutation,
  useGetDashboardAttendanceAnalyticsDataQuery,
  useGetAttendanceLogQuery,
} = attendanceReportApi;
